import Styles from 'flows/common/steps/BrandKitInstructions/BrandKitInstructions.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { BrandStyle } from 'blaze-ui/icons/32'
import { TurnWebsitesIntoContent } from 'blaze-ui/icons/24'

export const DesktopInstructions = () => (
  <div className={Styles.container}>
    <div className={Styles.section}>
      <div className={Styles.imagePlaceholder}>
        <BrandStyle size={60} />
      </div>
      <div className={Styles.sectionContent}>
        <span className={Styles.sectionTitle}>What's a brand kit?</span>
        <Text color="var(--dark-60)">
          A personalized Brand Kit captures your voice, style, and visuals. No more generic AI content that sounds like
          everyone else.
        </Text>
      </div>
    </div>
    <div className={Styles.section}>
      <div className={Styles.imagePlaceholder}>
        <TurnWebsitesIntoContent size={60} />
      </div>
      <div className={Styles.sectionContent}>
        <span className={Styles.sectionTitle}>How do I create one?</span>
        <Text color="var(--dark-60)">
          Just paste in your website, and Blaze will automatically analyze your brand voice, pull your logo, colors, and
          fonts, and add any images and video to your BrandKit.
        </Text>
      </div>
    </div>
  </div>
)
